"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mesaLogoSrc = require('./mesa-logo.png');
exports.trianglesLogoSrc = require('./triangles-logo.png');
exports.trianglesLogoSVGSrc = require('./triangles-logo.svg');
exports.topographySrc = require('./topography.png');
exports.topographyTornSrc = require('./topography-torn.png');
